import React, { useEffect } from 'react';
import { Card, Page, Spinner, Stack } from '@shopify/polaris';

import { useNavigate } from 'react-router-dom';
export default function SubscriptionVerification () {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate('/shopify' + window.location.search.replace('charge_id', 'completed_charge_id'));
    }, 7000);
  }, [navigate]);

  return (
    <Page>
      <Card
        title='Thanks for your payment'
      >
        <Card.Section>
          Please wait whilst we update your subscription information.<br />
          <Stack spacing='loose'>
            <Spinner />
          </Stack>
        </Card.Section>
      </Card>
    </Page>
  );
}
